"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftJs = require("draft-js");

var _default = function _default(blockKey, editorState) {
  var currentContent = editorState.getCurrentContent();

  if (!currentContent.getBlockForKey(blockKey)) {
    return editorState;
  }

  var updatedBlockMap = currentContent.getBlockMap().delete(blockKey);

  var updatedContent = _draftJs.ContentState.createFromBlockArray(updatedBlockMap.toArray());

  var updatedSelection = _draftJs.SelectionState.createEmpty();

  var precedingBlockKey = currentContent.getKeyBefore(blockKey);

  if (precedingBlockKey) {
    var precedingBlock = currentContent.getBlockForKey(precedingBlockKey);
    var offset = precedingBlock ? precedingBlock.getLength() : 0;
    updatedSelection = _draftJs.SelectionState.createEmpty(precedingBlockKey).merge({
      anchorOffset: offset,
      focusOffset: offset
    });
  }

  var updatedEditorState = _draftJs.EditorState.push(editorState, updatedContent, 'remove-range');

  return _draftJs.EditorState.forceSelection(updatedEditorState, updatedSelection);
};

exports.default = _default;
module.exports = exports.default;